<template>
    <span v-if="colour"
          class="label label-default"
          :style="`background-color: #${colour};`"
    >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
</template>

<script>
    export default {
        name: "colour-block",

        props: ['colour'],
    }
</script>

<style scoped>
    .label {
        margin-left: 10px;
        margin-right: 10px;
        border: 1px solid gray;
    }
</style>
